import './js/background.js'
import './js/pcrosshairs.js'

import './css/base.css'
import './css/background.css'
import './css/skin.css'
